module.exports = __webpack_public_path__ + "static/media/hk.7e30d412.svg";